import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="border-t border-zinc-200 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img
            src="/eh-logo-black.png"
            alt="E Holtzhausen Inc — Attorneys and Conveyancers"
            className="h-16 w-auto object-contain -ml-1 mb-4"
          />
          <p className="text-sm text-zinc-600 max-w-md leading-relaxed">
            A South African legal practice focused on Conveyancing, Antenuptial Contracts and Trusts.
            Guided intake. Attorney-reviewed output.
          </p>
        </div>
        <div>
          <div className="text-overline mb-4">Practice</div>
          <ul className="space-y-2 text-sm text-zinc-600">
            <li><a href="/#services">Conveyancing</a></li>
            <li><a href="/#services">Antenuptial Contracts</a></li>
            <li><a href="/#services">Wills &amp; Trusts</a></li>
            <li><a href="/#services">Deceased Estate Administration</a></li>
          </ul>
        </div>
        <div>
          <div className="text-overline mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-zinc-600">
            <li><a href="mailto:estelle@ehinc.co.za" className="hover:text-zinc-900">estelle@ehinc.co.za</a></li>
            <li><a href="mailto:admin@ehinc.co.za" className="hover:text-zinc-900">admin@ehinc.co.za</a></li>
            <li><a href="tel:+27823011291" className="hover:text-zinc-900">082 301 1291</a></li>
            <li>Dunbrook Place, 1st Floor Building B</li>
            <li>151 Nicolson Road, Brooklyn, Pretoria</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200 px-6 py-6 text-xs text-zinc-500 max-w-7xl mx-auto flex flex-col sm:flex-row justify-between gap-2">
        <div>© {new Date().getFullYear()} E Holtzhausen Inc. All rights reserved.</div>
        <div>Information on this site is general and not legal advice.</div>
      </div>
    </footer>
  );
}
